import React, { FC } from "react";
import './Product.css';
const Product = (props) => {
  return (
    <div className="p" id = "projects">
      <div className="p-browser">
        <div className="p-circle"></div>
        <div className="p-circle"></div>
        <div className="p-circle"></div>
      </div>
      <div className="p-title">{props.title}</div>
      <a href={props.link} target="_blank" rel="noreferrer">
        <img className="p-img" src={props.img} alt="test" width="400vw" height="400vh"></img>
      </a>
    </div>
  )
}

export default Product